import TextField from '../Base/TextField/TextField';
import Tags from '../Tag/Tags';
import React, { useEffect, useRef, useState } from 'react';
import apiClient from '../../Services/NetteApiClient';
import PropTypes from 'prop-types';
import List from '../List/List';
import Text from '../Base/Text/Text';
import * as ReactDOM from 'react-dom';
import AutocompleteItem from './AutocompleteItem';

// @ts-ignore
import styles from './Autocomplete.module.scss';

export default function Autocomplete(props) {
	const [selected, setSelected] = useState(null);
	const [data, setData] = useState([]);
	const ref = useRef();

	useEffect(async () => {
		document.addEventListener('click', handleClickOutside, true);

		if (
			props.value &&
			typeof props.value !== 'undefined' &&
			props.value !== 'undefined'
		) {
			const { data } = await apiClient.get(
				`${props.searchUrl}?id=${props.value}`,
			);

			if (data) {
				setSelected(data);
			}
		}

		return () => {
			document.removeEventListener('click', handleClickOutside, true);
		};
	}, []);

	const handleClickOutside = event => {
		const domNode = ReactDOM.findDOMNode(ref.current);

		if (!domNode || !domNode.contains(event.target)) {
			setData([]);
		}
	};

	const handleOnSearch = async value => {
		const { data } = await apiClient.get(
			`${props.searchUrl}?autocomplete_query=${value}`,
		);

		setData(data);
	};

	const handleItemClick = item => {
		if (props.multiple) {
			const tempSelected = selected || [];

			if (tempSelected.find(s => s.id === item.id)) {
				handleItemRemove(item);
			} else {
				const newSelected = [...tempSelected, item];
				setSelected(newSelected);
				handleChanged(newSelected);
			}
		} else {
			setSelected(item);
			setData([]);
			handleChanged(item);
		}
	};

	const handleItemRemove = item => {
		if (props.multiple) {
			const newSelected = (selected || []).filter(t => t.id !== item.id);
			setSelected(newSelected);

			handleChanged(newSelected);
		} else {
			setSelected(null);
			handleChanged(null);
		}
	};

	const handleChanged = val => {
		props.onChange && props.onChange(val);
	};

	return (
		<div className={styles.container} ref={ref}>
			{!!props.multiple ? (
				<>
					{!!props.tags && <Tags tags={selected ?? []} onRemove={handleItemRemove} />}
					<TextField
						onChange={handleOnSearch}
						bounce={300}
						placeholder={props.placeholder}
					/>
				</>
			) : (
				<>
					{selected ? (
						<div className={`form-control ${styles.selected}`}>
							<Text tx={selected.label} />
							<a
								onClick={() => handleItemRemove(selected)}
								className={styles.removeSelected}
							>
								<img src={'/dist/icons/xmark-solid.svg'} width={'6px'} />
							</a>
						</div>
					) : (
						<TextField
							onChange={handleOnSearch}
							bounce={300}
							placeholder={props.placeholder}
						/>
					)}
				</>
			)}

			{!!data?.length && (
				<div className={styles.list}>
					<List
						items={data}
						itemTemplate={({ item }) => (
							<AutocompleteItem
								item={item}
								itemTemplate={props.itemTemplate}
								onClick={handleItemClick}
							/>
						)}
					/>
				</div>
			)}
		</div>
	);
}

Autocomplete.propTypes = {
	searchUrl: PropTypes.string.required,
	multiple: PropTypes.bool,
	tags: PropTypes.bool,
	itemTemplate: PropTypes.any.required,
};
